var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.803,
    height: 32,
    viewBox: "0 0 34.803 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.985,0.174,-0.174,0.985,5.022,0.761)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,203,160)",
    fillRule: "nonzero",
    d: "M 1.08 5.408 C 1.294 1.329 5.399 -0.136 7.438 0.01 C 9.118 0.13 9.655 1.689 9.597 2.529 C 9.357 6.008 8.768 15.989 8.672 17.045 C 8.672 18.005 9.152 18.725 10.112 18.725 C 12.032 18.725 12.751 15.845 14.551 15.845 C 15.631 15.845 15.913 16.685 15.87 17.405 C 15.391 25.443 9.032 28.922 4.234 28.922 C 0.755 28.922 -0.205 25.683 0.035 23.763 C 0.355 18.885 0.888 9.055 1.08 5.408 Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.985,-0.174,0.174,-0.985,29.781,31.239)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,196,72)",
    fillRule: "nonzero",
    d: "M 1.08 5.408 C 1.294 1.329 5.399 -0.136 7.438 0.01 C 9.118 0.13 9.655 1.689 9.597 2.529 C 9.357 6.008 8.768 15.989 8.672 17.045 C 8.672 18.005 9.152 18.725 10.112 18.725 C 12.032 18.725 12.751 15.845 14.551 15.845 C 15.631 15.845 15.913 16.685 15.87 17.405 C 15.391 25.443 9.032 28.922 4.234 28.922 C 0.755 28.922 -0.205 25.683 0.035 23.763 C 0.355 18.885 0.888 9.055 1.08 5.408 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3f76609e31c96c6c13a2cbfdc7b5e76e.svg";
export { ForwardRef as ReactComponent };